export const WEB_PUSH_SUPPRESSION = Object.freeze({
  MANUAL_OFF: "manual-off",
  PERMISSION_DISMISSED: "permission-dismissed",
  PERMISSION_DENIED: "permission-denied",
});

const SUPPRESSION_VALUES = new Set(Object.values(WEB_PUSH_SUPPRESSION));

function hasScopedIdentity(siteId, userId) {
  return Number(siteId) > 0 && Number(userId) > 0;
}

export function buildWebPushSuppressionKey(siteId, userId) {
  if (!hasScopedIdentity(siteId, userId)) return "";
  return `web-push:suppression:${siteId}:${userId}`;
}

export function getWebPushSuppression(storage, siteId, userId) {
  if (!storage) return null;
  const key = buildWebPushSuppressionKey(siteId, userId);
  if (!key) return null;

  try {
    const value = storage.getItem(key);
    return SUPPRESSION_VALUES.has(value) ? value : null;
  } catch {
    return null;
  }
}

export function setWebPushSuppression(storage, siteId, userId, suppression) {
  if (!storage || !SUPPRESSION_VALUES.has(suppression)) return;
  const key = buildWebPushSuppressionKey(siteId, userId);
  if (!key) return;

  try {
    storage.setItem(key, suppression);
  } catch {
    // Browsers can deny storage access in restricted privacy modes.
  }
}

export function clearWebPushSuppression(storage, siteId, userId) {
  if (!storage) return;
  const key = buildWebPushSuppressionKey(siteId, userId);
  if (!key) return;

  try {
    storage.removeItem(key);
  } catch {
    // Browsers can deny storage access in restricted privacy modes.
  }
}

export function getPermissionSuppression(permission) {
  if (permission === "default") {
    return WEB_PUSH_SUPPRESSION.PERMISSION_DISMISSED;
  }
  if (permission === "denied") {
    return WEB_PUSH_SUPPRESSION.PERMISSION_DENIED;
  }
  return null;
}

export function shouldAutoSubscribeToWebPush({
  isUserLogin,
  userId,
  siteId,
  isLoading,
  isSupported,
  permission,
  suppression,
}) {
  if (!isUserLogin || isLoading || !hasScopedIdentity(siteId, userId)) return false;
  if (!isSupported || suppression) return false;
  return permission === "default" || permission === "granted";
}
